module.exports = __webpack_public_path__ + "img/logo-ci.65815392.png";